// THUMBNAIL SLIDER
var swiperThumbs = null;
var thumbsEl = document.querySelector('.Index_object_table_column_text_slider');

if (thumbsEl) {
    swiperThumbs = new Swiper('.Index_object_table_column_text_slider', {
        loop: false,
        grabCursor: false,
        spaceBetween: 8,
        slidesPerView: "auto",
        slideToClickedSlide: true,
        watchSlidesProgress: true,
        freeMode: true,
        watchOverflow: true,
        threshold: 10,
        observer: true,
        observeParents: true,
        mousewheel: {
            forceToAxis: true
        },
        scrollbar: {
            el: '.swiper-scrollbar',
        }
    });
}


// MAIN SLIDER
var mainEl = document.querySelector('.Index_object_table_column_item_slider');

if (mainEl) {
    var swiperMain = new Swiper('.Index_object_table_column_item_slider', {
        loop: false,
        grabCursor: false,
        spaceBetween: 10,
        slidesPerView: 1,
        autoHeight: true,
        watchOverflow: true,
        threshold: 10,
        observer: true,
        observeParents: true,
        mousewheel: {
            forceToAxis: true
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },

        // 🔗 Link thumbnails
        thumbs: {
            swiper: swiperThumbs,
        },

        // 🔄 Keep thumbnail visible when slide changes
        on: {
            slideChange: function () {
                if (swiperThumbs) {
                    swiperThumbs.slideTo(this.activeIndex);
                }
            }
        }
    });
}